module.exports = __webpack_public_path__ + "static/img/rank-bg.2cecc7e3.png";